import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-terms-of-use',
  imports: [],
  templateUrl: './terms-of-use.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './terms-of-use.scss',
})
export class TermsOfUse {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Terms of Use';
  protected readonly seoDescription =
    'Review Mari Group’s Terms of Use to understand the conditions governing access, use, and participation in our website and services.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Terms of Use', path: '/terms-of-use' },
      ],
    });
  }
}
